module.exports = __webpack_public_path__ + "static/Banner 1 tqm-c046a866460f3c2de7ec6a1be68c68bd.png";